import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaPhone } from 'react-icons/fa';
import { theme } from '../utils/theme';
import { device } from '../utils/mediaQueries';

const ContactSection = styled.section`
  min-height: 100vh;
  min-height: 100dvh;
  padding: 80px 20px;
  background: ${theme.background};
  color: ${theme.text};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  ${device.tablet} {
    padding: 100px 40px;
  }

  ${device.laptop} {
    padding: 120px 60px;
  }
`;

const Container = styled.div`
  max-width: 650px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;

const Subtitle = styled(motion.p)`
  color: ${theme.secondary};
  font-family: ${theme.fontMono};
  font-size: 0.9rem;
  margin-bottom: 1rem;
  letter-spacing: 0.05em;
  
  ${device.tablet} {
    font-size: 1rem;
  }
`;

const Title = styled(motion.h2)`
  font-size: clamp(1.75rem, 5vw, 3rem);
  margin-bottom: 1.25rem;
  color: ${theme.white};
  font-weight: 700;
  letter-spacing: -0.02em;

  ${device.tablet} {
    margin-bottom: 1.5rem;
  }
`;

const Description = styled(motion.p)`
  color: ${theme.text};
  font-size: 0.95rem;
  margin-bottom: 2rem;
  line-height: 1.7;
  max-width: 550px;
  margin-left: auto;
  margin-right: auto;
  
  ${device.tablet} {
    font-size: 1.05rem;
    margin-bottom: 2.5rem;
  }
`;

const EmailLink = styled(motion.a)`
  display: inline-block;
  padding: 0.85rem 2rem;
  background: ${theme.white};
  color: ${theme.background};
  text-decoration: none;
  border-radius: 50px;
  font-family: ${theme.fontMono};
  font-size: 0.9rem;
  font-weight: 500;
  transition: ${theme.transition};
  margin-bottom: 2.5rem;
  border: 1px solid ${theme.white};
  -webkit-tap-highlight-color: transparent;

  ${device.tablet} {
    padding: 1rem 2.5rem;
    font-size: 1rem;
    margin-bottom: 3rem;
  }

  &:hover {
    background: transparent;
    color: ${theme.white};
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(255, 255, 255, 0.15);
  }
`;

const SocialLinks = styled(motion.div)`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;

  a {
    color: ${theme.text};
    font-size: 1.5rem;
    transition: ${theme.transition};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.08);

    &:hover {
      color: ${theme.white};
      border-color: rgba(255, 255, 255, 0.2);
      transform: translateY(-2px);
    }
  }

  ${device.tablet} {
    gap: 1.25rem;
    margin-bottom: 4rem;
    
    a {
      font-size: 1.6rem;
    }
  }
`;

const Footer = styled.footer`
  margin-top: 2rem;
  font-family: ${theme.fontMono};
  font-size: 0.8rem;
  color: ${theme.text};
  opacity: 0.5;
  
  p {
    margin: 0.3rem 0;
  }
`;

const Contact = () => {
  return (
    <ContactSection id="contact">
      <Container>
        <Subtitle data-aos="fade-up">
          What's next?
        </Subtitle>
        <Title data-aos="fade-up" data-aos-delay="100">
          Get In Touch
        </Title>
        <Description data-aos="fade-up" data-aos-delay="200">
          I'm always interested in new opportunities and collaborations. Feel free to reach out
          if you'd like to discuss a project, ask questions, or just connect!
        </Description>

        <EmailLink
          href="mailto:gokulkannangk28@gmail.com"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          Say Hello
        </EmailLink>

        <SocialLinks data-aos="fade-up" data-aos-delay="400">
          <a href="https://github.com/gokulakannan69" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <FaGithub />
          </a>
          <a href="https://www.linkedin.com/feed/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedin />
          </a>
          <a href="mailto:gokulkannangk28@gmail.com" aria-label="Email">
            <FaEnvelope />
          </a>
          <a href="tel:+919361443302" aria-label="Phone">
            <FaPhone />
          </a>
        </SocialLinks>

        <Footer>
          <p>Designed & Built by Gokulakannan</p>
          <p>© {new Date().getFullYear()}</p>
        </Footer>
      </Container>
    </ContactSection>
  );
};

export default Contact;